<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'
import { ExchangeAvatar } from '#ui-kit/blocks/avatars'
import ColumnCell from './ColumnCell.vue'

const props = defineProps<{
  name: string
  description?: string | null
  image?: string | null
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div :class="cn('flex min-w-0 items-center gap-2 px-2', props.class)">
    <ExchangeAvatar :src="image" />
    <div class="flex min-w-0 flex-col text-xs">
      <ColumnCell :value="name" truncate class="p-0 font-semibold" />
      <span v-if="description" class="truncate text-gray-600">{{ description }}</span>
    </div>
  </div>
</template>
